import { BOX_SHADOWS } from 'constants/index';

const MuiMenu = {
  list: {
    minWidth: '200px',
    padding: '8px',
  },
  paper: {
    boxShadow: BOX_SHADOWS.card,
  },
};

export default MuiMenu;
